var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"Presentation--Container",style:({ backgroundImage: `url(${_vm.getImage('back-home-page.jpeg')})` }),attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('span',{staticClass:"Presentation--Title"},[_vm._v(" "+_vm._s(_vm.$t("App.Lexicon.Presentation.Title"))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }